import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CompetitionBadge from './CompetitionBadge';
import { isEntrantJudge, isAdminJudge, isAlsoViewer } from '../utils/roles';

export default function JudgeHeader() {
  const { user, logout } = useAuth();
  const { pathname }     = useLocation();

  // Dashboard only. This header is also on JudgeEvaluate, and a prominent
  // "switch away" button on a half-finished score sheet is an invitation to
  // lose work mid-evaluation.
  const onDashboard = pathname === '/judge/dashboard';
  const showSwitch  = isEntrantJudge(user) && onDashboard;
  // An admin who judges needs the way back, since login always drops them on
  // the admin dashboard and they arrived here through the strip over there.
  const showAdminBack = isAdminJudge(user) && onDashboard;
  // Granted the results page (Viewers panel) on top of judging.
  const showResults   = isAlsoViewer(user) && onDashboard;

  return (
    <>
      <header className="c-header">
        <div className="c-header__brand">
          <Link to="/judge/dashboard" className="c-header__logo">
            <span className="scala">SCALA</span>{' '}
            <span className="c-header__logo-sub">Song Competition</span>
            <CompetitionBadge />
          </Link>
        </div>

        <div className="c-header__right">
          <span className="c-header__user">{user?.full_name}</span>
          <button onClick={logout} className="c-header__logout">
            Sign out
          </button>
        </div>
      </header>

      {/* Only the handful of people who are both a judge and an entrant see this.
          It carries the explanation as well as the button: a judge halfway
          through scoring does not necessarily remember that his own two FOOM
          Live songs live behind a different dashboard. */}
      {showAdminBack && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You are signed in as an administrator</span>
          <Link to="/admin/dashboard" className="c-btn c-roleswitch__btn">
            Back to admin view →
          </Link>
        </div>
      )}

      {showSwitch && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You are also a FOOM entrant</span>
          <Link to="/contestant/dashboard" className="c-btn c-roleswitch__btn">
            Switch to entrant view →
          </Link>
        </div>
      )}

      {showResults && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You have access to the FOOM results</span>
          <Link to="/viewer/results" className="c-btn c-roleswitch__btn">
            FOOM results →
          </Link>
        </div>
      )}
    </>
  );
}
